module.exports = __webpack_public_path__ + "img/ability.e9c18aec.png";